<template>
  <v-container>
    <h1 class="">Bibliografia</h1>

    <div class="text-content">

    <ul>
    <li>Cinganotto, Letizia. (2019). «Gamification and virtual worlds for language learning». Form@re - Open Journal per la formazione in rete Vol. 19 No. 1 (aprile 30): 133-148 Pages. doi:10.13128/FORMARE-24770.</li>
    <li>Mantelli, Alessandro. (2020). «Analisi delle criticità nell’apprendimento dei kanji a livello avanzato e possibili strategie E-learning.» Aistugia Atto di convegno: 71–89.</li>
    <li>Mantelli, Alessandro. (2021). «Development of a Kanji Reference Tool and its Moodle Integration». EDUCAZIONE LINGUISTICA LANGUAGE EDUCATION 10: 117–140. doi:10.30687/ELLE/2280-6792/2021/01.</li>
    <li>Mantelli, Alessandro. (2021). E-learning sostenibile per la didattica del giapponese. Progettare per l’apprendimento autonomo. Vol. 16. Edizioni Ca’Foscari. doi:10.30687/978-88-6969-554-4.</li>
    <li>Marczewski, Andrzej. (2013). Gamification: a simple introduction & a bit more.</li>
    <li>Ryan, Richard; Deci, Edward. (2000). «Self-Determination Theory and the Facilitation of Intrinsic Motivation, Social Development, and Well-Being». American Psychologist 55 (1): 58–68.</li>
  </ul>
  </div>
   </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>